import React, {Component, Fragment} from 'react';
import {Link, withRouter} from "react-router-dom";
import {countDeliveryPrice} from "../../actionCreators";
import {connect} from "react-redux";
import Recaptcha from 'react-recaptcha';

const captchaKey = window.getConfig.siteKey;

class DeliveryAddressMain extends Component {
  constructor(props) {
    super(props);
    this.autocompleteInput = React.createRef();
    this.autocomplete = null
    this.state = {
      isSend: false,
      isSubmittedForm: false,
      form : {
        address: null,
        country: null,
        city: null,
        zip: null,
        street: null,
        house: null,
        floor: null,
        flat: null,
        buildingElevator: false,
        deliveryTo: true,
        deliveryToSecond: false,
        deliveryExpress: null,
        token: null
      }
    }
  }

  verifyCallback = (response) => {
    this.setState({
      form: {
        ...this.state.form,
        token: response
      }
    })
  }

  recaptchaLoaded = () => {
    console.log('recaptchaLoaded');
  }

  handleInputChange = (event) => {
    const {deliveryAddress} = this.props;
    const dataChange = event.currentTarget.dataset.changed;
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    if(!value && deliveryAddress) {
      deliveryAddress.delivery_address[dataChange] = ""
    }
    this.setState({
      form: {
        ...this.state.form,
        [name]: value
      }
    });
  };

  handleDeliveryTo = (event) => {
    const {deliveryAddress} = this.props;
    const value = +event.currentTarget.dataset.val;
    if(!value) {
      this.setState({
        form: {
          ...this.state.form,
          deliveryTo: true,
          deliveryToSecond: false
        }
      });
      if(deliveryAddress) {
        deliveryAddress.delivery_to_flat = true;
      }
    } else {
      this.setState({
        form: {
          ...this.state.form,
          deliveryTo: false,
          deliveryToSecond: true
        }
      });
      if(deliveryAddress) {
        deliveryAddress.delivery_to_flat = false;
      }
    }
  };

  handleDeliveryExpress = (event) => {
    const value = event.target.value;
    this.setState({
      form: {
        ...this.state.form,
        deliveryExpress: value
      }
    });

    const {deliveryAddress} = this.props;
    if(deliveryAddress) {
      deliveryAddress.express_delivery = value;
    }
  };

  handleDeliveryElevator = (event) => {
    const {deliveryAddress} = this.props;
    const value = event.target.value;
    this.setState({
      form: {
        ...this.state.form,
        buildingElevator: !JSON.parse(value)
      }
    });
    if(deliveryAddress) {
      deliveryAddress.delivery_address.elevator_available = !JSON.parse(value);
    }
  };

  handleBackToCart = () => {
    const {history, shopHashUrl} = this.props;
    history.push(`/shop/${shopHashUrl}`);
  };

   handleMoveDeliverySteps = () => {
    const {address, country, city, zip, street, house, flat, floor, buildingElevator, deliveryTo, deliveryExpress, token} = this.state.form;
    const {countDeliveryPrice, cart, deliveryAddress, shopHashUrl} = this.props;

    this.setState({
      isSubmittedForm: true
    });

    const tempCart = [];
    cart.forEach(function(item){
      const tempObj = {};
      tempObj.id = item.id;
      tempObj.amount = +item.quantity;
      tempObj.price = item.cost;
      tempObj.size = item.size;
      tempObj.bring_in_window = item.bringInWindow;
      tempObj.installation = item.installation;
      tempCart.push(tempObj);
    });

    const fetchData = {};
    const fetchDataAddress = {};
    fetchDataAddress.address_string = address || (deliveryAddress && deliveryAddress.delivery_address.address_string);
    fetchDataAddress.country = country || (deliveryAddress && deliveryAddress.delivery_address.country);
    fetchDataAddress.city = city || (deliveryAddress && deliveryAddress.delivery_address.city);
    fetchDataAddress.street = street || (deliveryAddress && deliveryAddress.delivery_address.street);
    fetchDataAddress.house = house || (deliveryAddress && deliveryAddress.delivery_address.house);
    fetchDataAddress.zip = zip || (deliveryAddress && deliveryAddress.delivery_address.zip);
    fetchDataAddress.floor = +floor || (deliveryAddress && deliveryAddress.delivery_address.floor);
    fetchDataAddress.flat = flat || (deliveryAddress && deliveryAddress.delivery_address.flat);
    fetchDataAddress.elevator_available = (buildingElevator || (deliveryAddress && deliveryAddress.delivery_address.elevator_available)) === null ? false : (buildingElevator || (deliveryAddress && deliveryAddress.delivery_address.elevator_available)) ;
    fetchData.delivery_items = tempCart || (deliveryAddress && deliveryAddress.delivery_items);
    fetchData.delivery_address = fetchDataAddress;
    fetchData.delivery_to_flat = (deliveryTo ? true : false) || (deliveryAddress && deliveryAddress.delivery_to_flat);
    fetchData.express_delivery = JSON.parse(deliveryExpress || (deliveryAddress && deliveryAddress.express_delivery))
    fetchData.token = token

     this.setState({
       form: {
         ...this.state.form,
         address: address || (deliveryAddress && deliveryAddress.delivery_address.address_string),
         country: country || (deliveryAddress && deliveryAddress.delivery_address.country),
         city: city || (deliveryAddress && deliveryAddress.delivery_address.city),
         street: street || (deliveryAddress && deliveryAddress.delivery_address.street),
         house: house || (deliveryAddress && deliveryAddress.delivery_address.house),
         zip: zip || (deliveryAddress && deliveryAddress.delivery_address.zip),
         floor: floor || (deliveryAddress && deliveryAddress.delivery_address.floor),
         flat: flat || (deliveryAddress && deliveryAddress.delivery_address.flat),
         deliveryExpress: deliveryExpress || (deliveryAddress && deliveryAddress.express_delivery)
        }
     });

    if(
      (address || (deliveryAddress && deliveryAddress.delivery_address.address_string)) &&
      (country || (deliveryAddress && deliveryAddress.delivery_address.country)) &&
      (city || (deliveryAddress && deliveryAddress.delivery_address.city)) &&
      (street || (deliveryAddress && deliveryAddress.delivery_address.street)) &&
      (house || (deliveryAddress && deliveryAddress.delivery_address.house)) &&
      (zip || (deliveryAddress && deliveryAddress.delivery_address.zip)) &&
      (deliveryExpress || (deliveryAddress && deliveryAddress.express_delivery)) &&
      (floor || (deliveryAddress && deliveryAddress.delivery_address.floor)) &&
      token
    ) {
      countDeliveryPrice(shopHashUrl, fetchData);
      // countDeliveryPrice('aaa', fetchData);
      this.setState({
        isSend: true
      })
    } else {
      console.log('q2 not send ajax')
    }
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {deliveryAddressErrors, history} = this.props;
    if((deliveryAddressErrors && deliveryAddressErrors.length === 0) && this.state.isSend) {
      history.push('/delivery-order');
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
  };

  componentDidMount() {
    this.autocomplete = new window.google.maps.places.Autocomplete(this.autocompleteInput.current,
      {"types": ["geocode"]});
    this.autocomplete.setComponentRestrictions(
      {'country': ['de']});
    this.autocomplete.addListener('place_changed', this.handlePlaceChanged);
  }

  handlePlaceChanged = () => {
    const place = this.autocomplete.getPlace();
    const placeFormatted = place.formatted_address;
    const tempPlace = {};
    const address = {
      street_number: 'short_name',
      route: 'long_name',
      locality: 'long_name',
      administrative_area_level_1: 'short_name',
      country: 'long_name',
      postal_code: 'short_name'
    };
    // console.log('place')
    // console.log(place);
    // console.log(place.address_components);
    for (var i = 0; i < place.address_components.length; i++) {
      var addressType = place.address_components[i].types[0];
      if (address[addressType]) {
        var val = place.address_components[i][address[addressType]];
      }
      // console.log(addressType + ": " + val);
      tempPlace[addressType] = val;
    }
    // console.log('tempPlace')
    // console.log(tempPlace)

    this.setState({
      form: {
        ...this.state.form,
        address: placeFormatted,
        country: tempPlace.country ? tempPlace.country : '',
        city: tempPlace.locality ? tempPlace.locality : '',
        street: tempPlace.route ? tempPlace.route : '',
        house: tempPlace.street_number ? tempPlace.street_number : '',
        zip: tempPlace.postal_code ? tempPlace.postal_code : ''
      }
    })
  }

  render() {
    const {address, country, city, zip, street, house, flat, floor, buildingElevator, deliveryExpress, deliveryTo, deliveryToSecond, token} = this.state.form;
    const {isSubmittedForm} = this.state;
    const {cart, deliveryAddress, deliveryAddressErrors} = this.props;
    const listErrorsDeliveryAddress = deliveryAddressErrors && deliveryAddressErrors.length !==0 ? deliveryAddressErrors.map((item) => <li key={item.message}>{item.message + ' '}</li>) : '';
    return (
      <Fragment>
        { cart.length !== 0 ? (
          <main className="index-shop">
            <section className="delivery-address">
              <h1>Wohin soll geliefert werden?</h1>
              <div className="delivery-address__wrap">
                <h2>Tragen Sie die Lieferadresse ein, um die Transportkosten zu berechnen.</h2>
                <form onSubmit={this.handleSubmit} method="POST" action="true">
                  <div className="delivery-address__form">
                    <div className="delivery-address__row">
                      <div className={"input-wrap input-wrap--common " + (!address && isSubmittedForm ? 'form__error' : '')}>
                        <label>Adresse</label>
                        <input ref={this.autocompleteInput} placeholder={''} id="autocomplete" name="address" type="text" onChange={this.handleInputChange} data-changed="address_string" defaultValue={address || (deliveryAddress && deliveryAddress.delivery_address.address_string)} required/>
                      </div>
                    </div>
                    <div className="delivery-address__row delivery-address__row--three">
                      <div className={"input-wrap input-wrap--common " + (!country && isSubmittedForm ? 'form__error' : '')}>
                        <label>Land</label>
                        <input disabled name="country" type="text" onChange={this.handleInputChange} data-changed="country" value={country || (deliveryAddress && deliveryAddress.delivery_address.country)} defaultValue={country || (deliveryAddress && deliveryAddress.delivery_address.country)} required />
                      </div>
                      <div className={"input-wrap input-wrap--common " + (!city && isSubmittedForm ? 'form__error' : '')}>
                        <label>Stadt</label>
                        <input disabled name="city" type="text" onChange={this.handleInputChange} data-changed="city" value={city || (deliveryAddress && deliveryAddress.delivery_address.city)} defaultValue={city || (deliveryAddress && deliveryAddress.delivery_address.city)} required />
                      </div>
                      <div className={"input-wrap input-wrap--common " + (!zip && isSubmittedForm ? 'form__error' : '')}>
                        <label>Postleitzahl</label>
                        <input disabled name="zip" type="text" onChange={this.handleInputChange} data-changed="zip" value={zip || (deliveryAddress && deliveryAddress.delivery_address.zip)} defaultValue={zip || (deliveryAddress && deliveryAddress.delivery_address.zip)} required />
                      </div>
                    </div>
                    <div className="delivery-address__row delivery-address__row--two">
                      <div className={"input-wrap input-wrap--common " + (!street && isSubmittedForm ? 'form__error' : '')}>
                        <label>Strasse</label>
                        <input disabled name="street" type="text" onChange={this.handleInputChange} data-changed="strret" value={street || (deliveryAddress && deliveryAddress.delivery_address.street)} defaultValue={street || (deliveryAddress && deliveryAddress.delivery_address.street)} required />
                      </div>
                      <div className={"input-wrap input-wrap--common " + (!house && isSubmittedForm ? 'form__error' : '')}>
                        <label>Hausnummer</label>
                        <input disabled name="house" type="number" onChange={this.handleInputChange} data-changed="house" value={house || (deliveryAddress && deliveryAddress.delivery_address.house)} defaultValue={house || (deliveryAddress && deliveryAddress.delivery_address.house)} required />
                      </div>
                    </div>
                    <div className="delivery-address__row delivery-address__row--last">
                      <div className="delivery-address__left">
                        <div className="check-wrap check-wrap--common">
                          <input type="checkbox" name="buildingElevator" checked={(deliveryAddress && deliveryAddress.delivery_address.elevator_available) || buildingElevator} defaultValue={(deliveryAddress && deliveryAddress.delivery_address.elevator_available) || buildingElevator} onChange={this.handleDeliveryElevator} id="building" required />
                          <label htmlFor="building">Aufzug vorhanden</label>
                        </div>
                        <div className="radio-wrap radio-wrap--common">
                          <input type="radio" name="deliveryTo" data-val="0" checked={deliveryTo || (deliveryAddress && deliveryAddress.delivery_address.deliveryTo)} defaultValue={deliveryTo || (deliveryAddress && deliveryAddress.delivery_address.deliveryTo)} onChange={this.handleDeliveryTo} id="delivery-floor" required />
                          <label htmlFor="delivery-floor">Lieferung bis in die Wohnung</label>
                        </div>
                        <div className="radio-wrap radio-wrap--common">
                          <input type="radio" name="deliveryTo" data-val="1" checked={deliveryToSecond || (deliveryAddress && deliveryAddress.delivery_address.deliveryToSecond)} defaultValue={deliveryToSecond || (deliveryAddress && deliveryAddress.delivery_address.deliveryToSecond)} onChange={this.handleDeliveryTo} id="bring-door" required />
                          <label htmlFor="bring-door">LIeferung bis zur ersten Tür</label>
                        </div>
                      </div>
                      <div className="delivery-address__right">
                        <div className="delivery-address__row delivery-address__row--two">
                          <div className={"input-wrap input-wrap--common " + (!floor && isSubmittedForm ? 'form__error' : '')}>
                          {/*<div className="input-wrap input-wrap--common">*/}
                            <label>Etage</label>
                            <input name="floor" onChange={this.handleInputChange} data-changed="floor" defaultValue={floor || (deliveryAddress && deliveryAddress.delivery_address.floor)} type="number" required />
                            {!floor && isSubmittedForm ? (<div className="form__error">Bitte geben Sie die Etage ein</div>) : ('')}
                          </div>
                          <div className="input-wrap input-wrap--common">
                          {/*<div className={"input-wrap input-wrap--common " + (!flat && isSubmittedForm && deliveryTo ? 'form__error' : '')}>*/}
                            <label>Wohnung</label>
                            <input name="flat" onChange={this.handleInputChange} data-changed="flat" defaultValue={flat || (deliveryAddress && deliveryAddress.delivery_address.flat)} type="text" required /> </div>
                          <div className="captcha-wrap">
                            <div className={"form-error-captcha " + (!token && isSubmittedForm ? 'form__error--captcha' : '')}>
                              <Recaptcha
                                ref={(r) => this.captcha = r}
                                sitekey={captchaKey}
                                render="explicit"
                                verifyCallback={this.verifyCallback}
                                onloadCallback={this.recaptchaLoaded}
                                hl={"de"}
                              />
                            </div>
                            {!token && isSubmittedForm ? (<div className="form__error">Fill captcha</div>) : ('')}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={"delivery-address__btns" + (deliveryExpress === null && isSubmittedForm ? ' form__error--express' : '')}>
                      <button className={"delivery-address__btn delivery-address__btn--on-date " + (deliveryExpress === 'false' || ((deliveryAddress && deliveryAddress.express_delivery === false) || (deliveryAddress && deliveryAddress.express_delivery === 'false')) ? 'show' : '')} onClick={this.handleDeliveryExpress} style={{ opacity: deliveryExpress === 'false' || (deliveryAddress && deliveryAddress.express_delivery === false ? '1': '') }} value="false" type="button">gewünschter Liefertermin</button>
                      <button className={"delivery-address__btn delivery-address__btn--express " + (deliveryExpress === 'true' || ((deliveryAddress && deliveryAddress.express_delivery === true) || (deliveryAddress && deliveryAddress.express_delivery === 'true')) ? 'show' : '')} onClick={this.handleDeliveryExpress} style={{ opacity: deliveryExpress === 'true' || (deliveryAddress && deliveryAddress.express_delivery === true ? '1': '') }} value="true" type="button">Expresslieferung</button>
                    </div>
                    <ul className="form-error__list">{ deliveryAddressErrors && deliveryAddressErrors.length !==0 ? listErrorsDeliveryAddress : ('') }</ul>
                  </div>
                </form>
              </div>
              <button onClick={this.handleBackToCart} className="shop-btn shop-btn--prev shop-btn--common shop-btn-left--common" type="button" title="zurück" aria-label="zurück"/>
              <button onClick={this.handleMoveDeliverySteps} className="shop-btn shop-btn--next shop-btn--common shop-btn-right--common" type="button" title="Weiter zum Lieferpreis" aria-label="Weiter zum Lieferpreis"/>
            </section>
          </main>
          ) : (
            <main className="index-shop">
              <h1 className="not-found">Einkaufswagen ist leer</h1>
              <div className="not-found__return-wrap">
                <Link className="not-found__return" to="/shop">Kehre zum Shop zurück</Link>
              </div>
            </main>
        )}
      </Fragment>
    );
  }
}

export default withRouter(connect((state) => {
  return {
    deliveryAddressErrors: state.delivery.deliveryAddressErrors,
    deliveryAddress: state.delivery.deliveryAddress,
    shopHashUrl: state.categories.shopHashUrl,
    cart: state.cart
  }
}, {countDeliveryPrice})(DeliveryAddressMain));


// WEBPACK FOOTER //
// ./src/components/DeliveryAddress/DeliveryAddressMain.js